import React from "react"
import Error from "../components/error"

const handleErrors = res => {
  if (!res.ok) {
    console.warn("Error ", res.statusText)
    return <Error />
  }
  return res
}

export default handleErrors
